import { j as i } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as L, useContext as A, useState as B, useRef as M, useMemo as X, useCallback as G, useEffect as k } from "react";
import J from "../../../atoms/ScrollbarContainer/ScrollBarContainer.js";
import p from "../Table.module.scss.js";
import { TableContext as K } from "../Context/Table.js";
import O from "./TableControls/TableControls.js";
import Q from "./TableSegmentedControl/TableSegmentedControl.js";
const U = ($) => {
  const {
    headerControls: e,
    headerAdditionalControls: E,
    segmentedControl: u,
    pagination: R,
    tableSize: r,
    loading: f,
    testId: q,
    onScrollEnd: o,
    showNoDataPlaceholder: x,
    noDataPlaceholder: y,
    children: D
  } = $, { updateLoading: w } = A(K), [h, H] = B(!1), m = M(null), t = X(
    () => ({
      width: (r == null ? void 0 : r.width) ?? "100%",
      height: (x && !(r != null && r.height) ? "400px" : r == null ? void 0 : r.height) ?? "auto",
      minHeight: (r == null ? void 0 : r.minHeight) ?? "80px",
      maxHeight: (r == null ? void 0 : r.maxHeight) ?? "auto"
    }),
    [
      r == null ? void 0 : r.width,
      r == null ? void 0 : r.height,
      r == null ? void 0 : r.minHeight,
      r == null ? void 0 : r.maxHeight,
      x
    ]
  ), I = G(() => {
    var s, l, d, C, a, j, c, F, g, v, P, N;
    const n = m.current;
    h && document.fullscreenEnabled && document.fullscreenElement ? ((l = (s = n == null ? void 0 : n.classList) == null ? void 0 : s.remove) == null || l.call(s, p.fullScreen), (C = (d = n == null ? void 0 : n.style) == null ? void 0 : d.setProperty) == null || C.call(d, "width", `${t == null ? void 0 : t.width}`, "important"), (j = (a = n == null ? void 0 : n.style) == null ? void 0 : a.setProperty) == null || j.call(a, "hight", `${t == null ? void 0 : t.height}`, "important"), (F = (c = n == null ? void 0 : n.style) == null ? void 0 : c.setProperty) == null || F.call(c, "minHeight", `${t == null ? void 0 : t.minHeight}`, "important"), (v = (g = n == null ? void 0 : n.style) == null ? void 0 : g.setProperty) == null || v.call(g, "maxHeight", `${t == null ? void 0 : t.maxHeight}`, "important"), (P = document == null ? void 0 : document.exitFullscreen) == null || P.call(document), H(!1)) : n != null && n.requestFullscreen && (n.className = p.fullScreen, n.style.setProperty("width", "100%", "important"), n.style.setProperty("hight", "100%", "important"), n.requestFullscreen(), H(!0)), typeof (e == null ? void 0 : e.onFullScreenClick) == "function" && ((N = e == null ? void 0 : e.onFullScreenClick) == null || N.call(e));
  }, [e, h, t]);
  return k(() => {
    w(f ?? !1);
  }, [f, w]), k(() => {
    var n, s, l;
    (l = (s = (n = m.current) == null ? void 0 : n.style) == null ? void 0 : s.setProperty) == null || l.call(s, "--head-before-height", "56px");
  }, []), /* @__PURE__ */ i.jsxs(
    "div",
    {
      "data-testid": "table-container",
      ref: m,
      ...(t == null ? void 0 : t.width) && !h && {
        style: {
          overflowX: "scroll",
          width: t == null ? void 0 : t.width
        }
      },
      className: "pt-025",
      children: [
        e && /* @__PURE__ */ i.jsx(
          O,
          {
            ...e,
            ...e.onFullScreenClick && { onFullScreenClick: I },
            isFullScreen: h,
            headerAdditionalControls: E
          }
        ),
        /* @__PURE__ */ i.jsxs(
          "div",
          {
            className: p.table,
            ...!h && {
              style: {
                width: t == null ? void 0 : t.width
              }
            },
            children: [
              u && /* @__PURE__ */ i.jsx(Q, { ...u }),
              !f && x && y && /* @__PURE__ */ i.jsx("div", { className: p.emptyContainer, children: y }),
              /* @__PURE__ */ i.jsx("div", { className: "relative", children: /* @__PURE__ */ i.jsx(
                J,
                {
                  ...!R && { handleScrollEnd: () => o == null ? void 0 : o() },
                  handleScrollEnd: () => o == null ? void 0 : o(),
                  height: h ? "100%" : t == null ? void 0 : t.height,
                  minHeight: h ? "100%" : t == null ? void 0 : t.minHeight,
                  maxHeight: h ? "calc(100vh - 207px)" : t == null ? void 0 : t.maxHeight,
                  width: t == null ? void 0 : t.width,
                  className: "bg-color-bg-neutral-lightest-default",
                  children: /* @__PURE__ */ i.jsx(
                    "table",
                    {
                      "data-testid": q,
                      className: "relative",
                      children: D
                    }
                  )
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}, S = L(U);
export {
  S as default
};
//# sourceMappingURL=CustomTable.js.map
